import "@/App.css";
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WhatsAppButton from "@/components/WhatsAppButton";

// Dynamic imports for code splitting
const Home = lazy(() => import("@/pages/Home"));
const Blog = lazy(() => import("@/pages/Blog"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));
const AdminBlog = lazy(() => import("@/pages/AdminBlog"));
const SolutionPage = lazy(() => import("@/pages/SolutionPage"));
const Sustentabilidade = lazy(() => import("@/pages/Sustentabilidade"));
const CidadePage = lazy(() => import("@/pages/CidadePage"));
const FAQ = lazy(() => import("@/pages/FAQ"));
const QuantoCusta = lazy(() => import("@/pages/QuantoCusta"));
const NotFound = lazy(() => import("@/pages/NotFound"));

// Premium loading fallback
const LoadingFallback = () => (
  <div style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backgroundColor: "#0d0f12",
    color: "#ffc80a",
    fontFamily: "Geist, sans-serif",
    fontSize: "16px",
    gap: "16px"
  }}>
    <div style={{
      width: "36px",
      height: "36px",
      border: "3px solid rgba(255, 200, 10, 0.15)",
      borderTop: "3px solid #ffc80a",
      borderRadius: "50%",
      animation: "spin 0.8s linear infinite"
    }} />
    <span style={{ opacity: 0.8, letterSpacing: "0.05em" }}>Carregando CSI Locações...</span>
    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<LoadingFallback />}>
          <main>
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/admin/blog" element={<AdminBlog />} />
            <Route path="/solucoes/:slug" element={<SolutionPage />} />
            <Route path="/sustentabilidade" element={<Sustentabilidade />} />
            {["fortaleza", "recife", "natal", "salvador", "sao-luis", "teresina", "belem"].map((c) => (
              <Route key={c} path={`/aluguel-de-gerador-${c}`} element={<CidadePage />} />
            ))}
            <Route path="/faq" element={<FAQ />} />
            <Route path="/quanto-custa-alugar-gerador" element={<QuantoCusta />} />
            <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <WhatsAppButton />
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
